import { buttonVariants, cn, Container } from '@resolute/ui';
import { AnimatePresence, motion } from 'framer-motion';
import { GitCompare, X } from 'lucide-react';
import { Link } from 'react-router-dom';


import { MAX_COMPARE, useCompare } from './compare-context';

import { PANEL_TRANSITION } from '@/lib/motion';


/** Sticky bar that appears when properties are queued for comparison. */
export function CompareBar() {
  const { items, count, remove, clear } = useCompare();

  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={PANEL_TRANSITION}
          className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-card/95 backdrop-blur"
          role="region"
          aria-label="Compare properties"
        >
          <Container className="flex items-center gap-4 py-3">
            <span className="hidden items-center gap-2 text-sm font-medium sm:flex">
              <GitCompare className="size-4 text-primary" aria-hidden="true" />
              Compare ({count}/{MAX_COMPARE})
            </span>
            <ul className="flex flex-1 items-center gap-2 overflow-x-auto">
              {items.map((p) => (
                <li
                  key={p.id}
                  className="flex shrink-0 items-center gap-1.5 rounded-md border border-border bg-background px-3 py-1.5 text-sm"
                >
                  <span className="max-w-[10rem] truncate">{p.title}</span>
                  <button
                    type="button"
                    onClick={() => remove(p.id)}
                    aria-label={`Remove ${p.title} from compare`}
                    className="text-muted-foreground hover:text-foreground"
                  >
                    <X className="size-3.5" aria-hidden="true" />
                  </button>
                </li>
              ))}
            </ul>
            <div className="flex shrink-0 items-center gap-2">
              <button
                type="button"
                onClick={clear}
                className="text-sm text-muted-foreground hover:text-foreground"
              >
                Clear
              </button>
              <Link
                to="/compare"
                className={cn(
                  buttonVariants({ variant: 'primary', size: 'sm' }),
                  count < 2 && 'pointer-events-none opacity-50',
                )}
                aria-disabled={count < 2}
              >
                Compare
              </Link>
            </div>
          </Container>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
